import { createSelector } from 'reselect';

import { getProgramsCategory } from './programsCategory.selectors';

export const selectEscrowRequirementsSchema = createSelector(
  getProgramsCategory,
  ({ escrowRequirementsSchema }) => escrowRequirementsSchema,
);
